import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from './EnhancedDashboard.module.css';
import { axiosPrivateInstance } from "../../axios";
import EnhancedSubDashboard from "./EnhancedSubDashboard";
import { useTranslation } from 'react-i18next';


function EnhancedDashboard() {
   const { t, i18n } = useTranslation();
    const [namespaces, setNamespaces] = useState([]);
    const [projects, setProjects] = useState([]);
    const [isProjectSelected, setIsProjectSelected] = useState(false)
    const [computedProjects, setComputedProjects] = useState([]);
    const [selectedNamespace, setSelectedNamespace] = useState("");
    const [computedSelectedNamespace, setComputedSelectedNamespace] = useState("");
    const [loadingNamespaces, setLoadingNamespaces] = useState(true);
    const [loadingProjects, setLoadingProjects] = useState(true);
    const [isNamespaceSelected, setIsNamespaceSelected] = useState(false);
    const [computedIsNamespaceSelected, setComputedIsNamespaceSelected] = useState(false);
    const [selectedProject, setSelectedProject] = useState("");
    const [computedSelectedProject, setComputedSelectedProject] = useState("");
    const [doesExist, setDoesExist] = useState(false);
    const [downloadingProject, setDownloadingProject] = useState(false);
    const [path, setPath] = useState();
    const [files, setFiles] = useState([]);
    const [numberOfDownloadedFiles, setNumberOfDownloadedFiles] = useState(0);
    const [allGpkgData, setAllGpkgData] = useState([]);
    const [containsNonEnglishLayerName, setContainsNonEnglishType] = useState(false);
    const [errorOnDownload, setErrorOnDownload] = useState("");
    const [listOfGpkgFiles, setListOfGpkgFiles] = useState([]);
    const [fetchingFileText, setFetchingFileText] = useState("");
    const [nonExistedFiles, setNonExistedFiles] = useState([]);
    const [existedFiles, setExistedFiles] = useState([]);
    const [countedFiles, setCountedFiles] = useState(0);
    
    
    const [checkedFiles, setCheckedFiles] = useState(0);
    const [fileNames, setFileNames] = useState([]);
    const [openSubDashboard, setOpenSubDashboard] = useState(false);
    const [isRefreshButtonDisabled, setIsRefreshButtonDisabled] = useState(false);

    
    
   useEffect(() => {
        //console.log("SEROO");

        async function getNamespaces() {
            await axiosPrivateInstance.get('mergintransactions/getnamespaceslist').then(res => {
                setNamespaces(res.data)
                setLoadingNamespaces(false);
                //console.log(res.data)
            }).catch(err => {
                console.error(err);
                if(err.status == 401){
                    window.location.reload();
                }
            });
        }


        getNamespaces()

    }, [])
    
    
    





    useEffect(() => {
        setComputedIsNamespaceSelected(isNamespaceSelected);
        setComputedSelectedNamespace(selectedNamespace);
    }, [isNamespaceSelected])


    useEffect(() => {
        setFiles([]); 
        setFileNames([]);
        setDoesExist(false);
        setLoadingProjects(true);
        setIsProjectSelected(false);
        axiosPrivateInstance.post('mergintransactions/getprojectslist', JSON.stringify({
            namespace: selectedNamespace
        }), {
            headers: {
                "Content-Type": "application/json"
            }
        }).then(res => {
            //console.log(res.data);
            if (res.status === 200) {

                setProjects(res.data)
                setLoadingProjects(false);
            }
        }).catch(res => {
            console.error(res);
            return;
        })
    }, [selectedNamespace]);



    useEffect(() => {
        if(openSubDashboard){ 
            setDownloadingProject(false);
        }
    }, [openSubDashboard])


    const handleNamespaceSelection = (e) => {
        setSelectedNamespace(e.target.value);
        setIsNamespaceSelected(true);
        setSelectedProject("");
        setIsProjectSelected(false);
        setOpenSubDashboard(false);
    }

    const handleProjectSelection = (e) => {
        setSelectedProject(e.target.value);
        setIsProjectSelected(true);
        setDownloadingProject(true);
    }

    useEffect(() => {
        setFiles([]); 
        setFileNames([]);
        setDoesExist(false);
        setOpenSubDashboard(false);
        if(isNamespaceSelected && isProjectSelected && (selectedProject != -1 || selectedProject != "-1") )
        {

		setCountedFiles(0);
		setNumberOfDownloadedFiles(0);
		axiosPrivateInstance.post('mergintransactions/doesexist', JSON.stringify({
		    namespace: computedSelectedNamespace,
		    project_name: selectedProject
		})).then(async doesExistRes => {
		    //if folder exist, receive (set) files, else download project and receive (set) files
		    let gpkgList = [];
		         await axiosPrivateInstance.post('mergintransactions/projectinfo', JSON.stringify({
	    				project_path_or_id: computedSelectedNamespace+'/'+selectedProject
	    		 })).then((res) => {
	    		       if(res.data && res.data.files){
	    		             res.data.files.map(
	    				(file) => {
	    					if(file.path.includes('.gpkg')){
	    						gpkgList.push(file.path);
	    					}
	    				}
	    			)
	    			setAllGpkgData(gpkgList);
	    		       }
	    		 }).catch(err => console.log(err))            
		    if(doesExistRes.data.doesExist){
		         let fileContent = [];
		    	 setFetchingFileText(selectedProject + t("fetchingFileTextExistMessage"));	
		         for(let i=0; i<gpkgList.length; i++){
		             setTimeout(() => {
		             axiosPrivateInstance.post("mergintransactions/checkforfile", JSON.stringify({
					filename: gpkgList[i],
					project_name: selectedProject
				})).then(async checkForFileRes => {
//					    		setCheckedFiles(i);
					    		if(checkForFileRes.status == 200 && checkForFileRes.data.exists){
					    			//collect content of relevant file
					    			
					    	try {
						    // Perform the request and wait until the response status is 200
						    let res;
						    let attempts = 0;
						    const maxAttempts = 5; // You can set a max attempt count to avoid an infinite loop

						    // Wait until the response status is 200 or max attempts reached
						    while (attempts < maxAttempts) {
							const path_local = `./../projects/${selectedProject}/${gpkgList[i]}`;
							res = await axiosPrivateInstance.post('mergintransactions/returnfilecontent', JSON.stringify({
							    path: path_local
							}));

							// If the status is 200, break the loop
							if (res.status === 200) {
							    break;
							}

							// Optionally, add a delay before retrying (to avoid hammering the server too quickly)
							await new Promise(resolve => setTimeout(resolve, 8500)); // 3.5-second delay between retries

							attempts++;
						    }

						    if (res && res.status === 200) {
							// Process the successful response

							setFetchingFileText(gpkgList[i]+t("fetchingFileContentRetrieved"));
							fileContent.push({
							     fileName: gpkgList[i],
						             data: res.data
							});
							
							    setFiles(prevFiles => [
								...prevFiles, // Spread the previous files
								{
								    fileName: gpkgList[i],
								    data: res.data
								}
							    ]);
										
						    } else {
							console.error('Request failed after maximum retries');
						    }

						} catch (error) {
							    // Handle any errors during the request
							    console.error('Error on returning file content');
							    console.error(error)
						}
					    		}	
					    		
					    		
					    }).catch(err => console.log(err));
		             }, i * 8500)
		             
		         } 
		         
		    }     
		    else{
		        let fileContent = [];
		    	
		    	setFetchingFileText(selectedProject + t('fetchingFileRefreshContent'));
			for(let i=0; i<gpkgList.length; i++){
			    setTimeout(() => {
			        axiosPrivateInstance.post('mergintransactions/downloadfile', JSON.stringify({
				    namespace: computedSelectedNamespace,
				    project_name: selectedProject,
				    file_path: gpkgList[i]
				}))
				.then(async (downloadFileRes) => {
				    if(downloadFileRes.status == 200){
					console.log("downloadFileRes");
					console.log(downloadFileRes)		
    				        
			                      await axiosPrivateInstance.post("mergintransactions/checkforfile", JSON.stringify({
							filename: gpkgList[i],
							project_name: selectedProject
						})).then(async checkForFileRes => {
						console.log("checkForFileRes => ", checkForFileRes)
//					    		setCheckedFiles(i);
					                					    		if(checkForFileRes.status == 200 && checkForFileRes.data.exists){
					    			//collect content of relevant file
					    			
					    	try {
						    // Perform the request and wait until the response status is 200
						    let res;
						    let attempts = 0;
						    const maxAttempts = 5; // You can set a max attempt count to avoid an infinite loop

						    // Wait until the response status is 200 or max attempts reached
						    while (attempts < maxAttempts) {
							const path_local = `./../projects/${selectedProject}/${gpkgList[i]}`;
							res = await axiosPrivateInstance.post('mergintransactions/returnfilecontent', JSON.stringify({
							    path: path_local
							}));

							// If the status is 200, break the loop
							if (res.status === 200) {
							    break;
							}

							// Optionally, add a delay before retrying (to avoid hammering the server too quickly)
							await new Promise(resolve => setTimeout(resolve, 8500)); // 1-second delay between retries

							attempts++;
						    }
						    
						    if (res && res.status === 200) {
							// Process the successful response
							
							fileContent.push({
							     fileName: gpkgList[i],
						             data: res.data
							});
							
							setFiles(prevFiles => [
								...prevFiles, // Spread the previous files
								{
								    fileName: gpkgList[i],
								    data: res.data
								}
						         ]);

						    } else {
							console.error('Request failed after maximum retries');
						    }

						} catch (error) {
							    // Handle any errors during the request
							    console.error("Error on returning filecontent");
							    console.error(error);
						}
					    		}
					    }).catch(err => console.log(err));
	                            }
				    
				    
				}).catch(err => 
				{
				    console.log("FILE DOWNLOADING ERROR");
				    console.log(err);
				}
				);
			    }, i * 8500);	  
			}
			

		    }

		}).catch(err => {
		    console.error("ERROR ON CHECKING FILE");
		    console.error(err);
		    });

        
        }
        
    }, [selectedProject])
    
    
    
    

    useEffect(() => {

         if(files.length > 0 && files.length <= allGpkgData.length){
             	setFetchingFileText(`(${allGpkgData[files.length]}) ${files.length} / ${allGpkgData.length}`);
         }
         
         if(isNamespaceSelected && isProjectSelected && files.length > 0 && files.length >= allGpkgData.length){

		const fileNames = files.map(item => {
			return item.fileName
		});
		
		
		const fileNamesNoRepeat = fileNames.filter((item, index) => {
		  return fileNames.indexOf(item) === index;
		});
		
		if(fileNamesNoRepeat.length == allGpkgData.length){
                    console.log("fileNamesNoRepeat");
                    console.log(fileNamesNoRepeat);
                    setOpenSubDashboard(true);
		}
                setFetchingFileText(t("fetchingFileProjectOpening"));

                setTimeout(() => {
                  //receive filenames in there... temporarily may be permanently
                  axiosPrivateInstance.post('mergintransactions/returnfilenames', JSON.stringify({
						    path: `./../projects/${selectedProject}`
						})).then(res => {
						    if(res.status == 200)
						    {

						       setFileNames(res.data);
						       setDoesExist(true);
						       setDownloadingProject(true);                   
						    }   
						    setDownloadingProject(false);
						}).catch(err => { setDownloadingProject(false); console.error(err);});
                }, 2000);
         }
    }, [files, allGpkgData])
    
/*
    useEffect(() => {
        if(doesExist){
           setFetchingFileText("");
        }
    }, [doesExist])
  */  
  
  /*
    const deleteProject = async () => {
            setFiles([]); 
            setFileNames([]);
            setDoesExist(false);
            setDownloadingProject(true);
    	    await axiosPrivateInstance.post('mergintransactions/deletefolder', JSON.stringify({
    	        project_name: selectedProject
    	    })).then(async deleteProjectRes => {
    	        if(deleteProjectRes.status == 200)
    	        {
    	                 setFetchingFileText(selectedProject + t("fetchingFileRefreshContent"));         
    	                 let gpkgList = [];
		         await axiosPrivateInstance.post('mergintransactions/projectinfo', JSON.stringify({
	    				project_path_or_id: computedSelectedNamespace+'/'+selectedProject
	    		 })).then((projectInfoRes) => {
	    		       if(projectInfoRes.data && projectInfoRes.data.files){
	    		             projectInfoRes.data.files.map(
	    				(file) => {
	    					if(file.path.includes('.gpkg')){
	    						gpkgList.push(file.path);
	    					}
	    				}
	    			)
	    			console.log("Just before setting allGpkgData");
	    			console.log(gpkgList);
	    			setAllGpkgData(gpkgList);
	    		   for(let i=0; i<gpkgList.length; i++){
			    setTimeout(() => {
			        axiosPrivateInstance.post('mergintransactions/downloadfile', JSON.stringify({
				    namespace: computedSelectedNamespace,
				    project_name: selectedProject,
				    file_path: gpkgList[i]
				}))
				.then(async (downloadFileRes) => {
				
				    if(downloadFileRes.status == 200){

    				        
			                      await axiosPrivateInstance.post("mergintransactions/checkforfile", JSON.stringify({
							filename: gpkgList[i],
							project_name: selectedProject
						})).then(async checkForFileRes => {

//					    		setCheckedFiles(i);
					                					    		if(checkForFileRes.status == 200 && checkForFileRes.data.exists){
					    			//collect content of relevant file
					    			
					    	try {
						    // Perform the request and wait until the response status is 200
						    let res;
						    let attempts = 0;
						    const maxAttempts = 5; // You can set a max attempt count to avoid an infinite loop

						    // Wait until the response status is 200 or max attempts reached
						    while (attempts < maxAttempts) {
							const path_local = `./../projects/${selectedProject}/${gpkgList[i]}`;
							res = await axiosPrivateInstance.post('mergintransactions/returnfilecontent', JSON.stringify({
							    path: path_local
							}));
							
							console.log("attempts in return file content");
							console.log(attempts);
							


							// If the status is 200, break the loop
							if (res.status === 200) {
							    break;
							}

							// Optionally, add a delay before retrying (to avoid hammering the server too quickly)
							await new Promise(resolve => setTimeout(resolve, 5000)); // 1-second delay between retries

							attempts++;
						    }

						    if (res && res.status === 200) {
							// Process the successful response
							//console.log('Request succeeded:', res.data);
							console.log('downloadFileRes');
                           				console.log(downloadFileRes);
                           				console.log("checkForFileRes");
						        console.log(checkForFileRes);
							console.log("Response from returnfilecontent");
							console.log(res);
							

							
	
							console.log(gpkgList[i]);
							
							//If 
			
                                setFiles(prevFiles => {
  // Önce bu dosyanın zaten eklenip eklenmediğini kontrol ediyoruz
  const fileAlreadyExists = prevFiles.some(file => 
    file.fileName === gpkgList[i]
  );
  
  // Eğer dosya yoksa ve res.data geçerliyse ekliyoruz
  if (!fileAlreadyExists && res.data) {
    return [
      ...prevFiles,
      {
        fileName: gpkgList[i],
        data: res.data
      }
    ];
  }
  
  // Dosya zaten varsa veya res.data yoksa önceki state'i olduğu gibi döndürüyoruz
  return prevFiles;
});
						    } else {
							console.error('Request failed after maximum retries');
						    }

						} catch (error) {
							    // Handle any errors during the request
							    console.error('An error occurred while making the request:', error);
						}
					    		}
					    }).catch(err => console.log(err));
	                            }
				    
				    
				}).catch(err => console.log(err));
			    }, i * 5000);	  
			}
			
			
	    		       }
	    		 }).catch(err => console.log(err))
    	        }
    	    }).catch(err => console.log(err));
    	
    }
*/

const deleteProject = async () => {
    setFiles([]);
    setFileNames([]);
    setDoesExist(false);
    setDownloadingProject(true);
    setOpenSubDashboard(false);
    
    try {
        // 1. Projeyi silme isteği
        const deleteProjectRes = await axiosPrivateInstance.post(
            'mergintransactions/deletefolder',
            JSON.stringify({ project_name: selectedProject })
        );

        if (deleteProjectRes.status !== 200) return;

        setFetchingFileText(selectedProject + t("fetchingFileRefreshContent"));
        
        
        

        // 2. Proje bilgilerini çekme
        const projectInfoRes = await axiosPrivateInstance.post(
            'mergintransactions/projectinfo',
            JSON.stringify({ project_path_or_id: `${computedSelectedNamespace}/${selectedProject}` })
        );

        if (!projectInfoRes.data?.files) return;

        // 3. GPKG dosyalarını filtreleme (TEKİLLEŞTİRİLMİŞ)
        const gpkgList = [...new Set(
            projectInfoRes.data.files
                .filter(file => file.path.includes('.gpkg'))
                .map(file => file.path)
        )];

        setAllGpkgData(gpkgList);

        // 4. Dosyaları indirme ve içerikleri alma (PARALEL İŞLEM)
        await Promise.all(gpkgList.map(async (filePath, index) => {
            await new Promise(resolve => setTimeout(resolve, index * 8500));

            try {
                // A. Dosyayı indirme
                const downloadFileRes = await axiosPrivateInstance.post(
                    'mergintransactions/downloadfile',
                    JSON.stringify({
                        namespace: computedSelectedNamespace,
                        project_name: selectedProject,
                        file_path: filePath
                    })
                );

                if (downloadFileRes.status !== 200) return;
                
//                console.log("downloadFileRes");
//                console.log(downloadFileRes.data);
                let file_path;
                if(downloadFileRes.data.project_file_history)
                {
                    file_path = downloadFileRes.data.project_file_history;
                }
                

                
                
                // B. Dosya varlığını kontrol etme
                const checkForFileRes = await axiosPrivateInstance.post(
                    "mergintransactions/checkforfile",
                    JSON.stringify({
                        filename: filePath,
                        project_name: selectedProject
                    })
                );

                if (checkForFileRes.status !== 200 || !checkForFileRes.data.exists) return;

                // C. Dosya içeriğini alma (5 denemeli)
                let res;
                for (let attempt = 0; attempt < 5; attempt++) {
                    try {
                        res = await axiosPrivateInstance.post(
                            'mergintransactions/returnfilecontent',
                            JSON.stringify({ path: `./../projects/${selectedProject}/${filePath}` })
                        );
                        
                        if(file_path && res.data.data){
                            console.log("file_path and typeof file_path");
                            console.log(file_path, typeof file_path);
                        
                        
                        
                            console.log("returfilecontent res = ");
                            console.log(res.data.data);
                            console.log("first key of res.data.data");
                            console.log(Object.keys(res.data.data)[0])
                            console.log("as string file_path", String(file_path.path));
                            console.log("as string Objectkeys", String(Object.keys(res.data.data)[0]));
                            if ( String(file_path.path).includes(String(Object.keys(res.data.data)[0]))){
                                break;
                            }
                            else{
                                // Dosyayi kontrol et, yoksa indir
                               const downloadFileRes = await 	axiosPrivateInstance.post(
				    'mergintransactions/downloadfile',
				    JSON.stringify({
				        namespace: computedSelectedNamespace,
				        project_name: selectedProject,
				        file_path: filePath
				    })
				);

                if (downloadFileRes.status !== 200) continue;
                else break;
                            }
                        }
                        
                        //if (res.status === 200) break;
                        await new Promise(resolve => setTimeout(resolve, 8000));
                    } catch (error) {
                        console.error(`Attempt ${attempt + 1} failed:`, error);
                    }
                }

                if (!res || res.status !== 200) return;

                // D. STATE GÜNCELLEME (BENZERSİZ KONTROLLÜ)
                setFiles(prevFiles => {
                    const isDuplicate = prevFiles.some(f => f.fileName === filePath);
                    return isDuplicate 
                        ? prevFiles 
                        : [...prevFiles, { fileName: filePath, data: res.data }];
                });

            } catch (error) {
                console.error(`Error on downloading file and processing them for ${filePath}:`);
                console.error(error);
            }
        }));

    } catch (error) {
        console.error("Main error:", error);
    } 
};
    
    return(
         <>
        
        {
            errorOnDownload && errorOnDownload.length > 0 ? 
            <div className="d-flex justify-content-center flex-nowrap">
             <div className="bg-danger text-dark mx-2 p-2 w-75 text-wrap text-center border border-dark rounded">
                {errorOnDownload}
            </div>
             
          </div> 
            : ""
        }
            <div className="container" id={styles.mainFrame}>
            
            
                <div className="row text-center">
                
                
                    <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12" id={styles.namespaceSelectionFrame} key={Math.floor(Math.random() * 10000000000)}>
                        <b className="fs-5 text-dark">{t('enhancedDashboardNamespaceSelection')}</b>
                        <select onChange={(e) => handleNamespaceSelection(e)} value={selectedNamespace} className="form-select border border-danger" aria-label="Default select example" id="selectNamespace" disabled={downloadingProject}>
                            <option value="-1" selected>{loadingNamespaces ? t('enhancedDashboardNamespacesAreLoading') : t('enhancedDashboardPleaseSelectNamespace')}</option>
                            {
                                namespaces.map((item, index) => {

                                    return (
                                        <>
                                            <option value={item.name}>{item.name}</option>
                                        </>

                                    )
                                })
                            }

                        </select>
                    </div>


                    <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12" id={styles.refreshProjectFrame}>
                        {isNamespaceSelected && isProjectSelected ? <button id="refreshButton" onClick={() => {
                                deleteProject();
                                setIsRefreshButtonDisabled(true);
                                setTimeout(() => {
                                    setIsRefreshButtonDisabled(false);
                                }, 5500)
                            }
                        } className="btn btn-sm btn-danger" disabled={isRefreshButtonDisabled}>{t('enhancedDashboardRefreshProject')}</button> : ""}
                    </div>
                    
                  


                    <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12" id={styles.projectSelectionFrame}>
                        <b className="fs-5 text-dark">{t('enhancedDashboardProjectSelection')}</b>
                        <select onChange={(e) => handleProjectSelection(e)} value={selectedProject} className="form-select border border-danger" aria-label="Default select example" id="selectProject" disabled={downloadingProject}>
                            <option value="-1" selected>{computedIsNamespaceSelected ? loadingProjects ? t('enhancedDashboardProjectsLoading') : projects.length > 0 ? t('enhancedDashboardChooseProject') : t('enhancedDashboardProjectNotFound') : t('enhancedDashboardNamespaceNotSelected')}</option>
                            {
                                projects && projects.map(project => {
                                    return (
                                        <option value={project.name}>{project.name}</option>
                                    )
                                })
                            }

                        </select>
                    </div>


                </div>
                
                 {  downloadingProject && isNamespaceSelected &&  isProjectSelected && !isRefreshButtonDisabled ? <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 jumbotron jumbotron-fluid bg-danger my-2 border border-light fs-5 text-light mx-auto w-75">
                    {t('notProceedWarning')}
                    </div> : ""}
                    
                <div className="container-fluid text-center" id={styles.subMainFrame}>
                	{doesExist == false && (!fileNames || fileNames.length == 0) || openSubDashboard == false ? <h1 className="text-dark">{fetchingFileText}</h1> :  
                	                    <EnhancedSubDashboard data={files} files={fileNames} selectedProject={selectedProject} selectedNamespace={selectedNamespace}/>}
                </div>

</div>

        </>
    )
}

export default EnhancedDashboard;
